import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

const PIXEL_ID = '29805417609071542';

export default function MetaPixelAdvancedMatching() {
    const { isAuthenticated, user } = useAuth0();

    useEffect(() => {
        if (!isAuthenticated || !user) return;
        if (typeof window.fbq !== 'function') return;

        // Google login via Auth0 usually provides given_name/family_name.
        // Fall back to splitting `name` for connections that don't.
        let fn = user.given_name;
        let ln = user.family_name;
        if (!fn && !ln && user.name) {
            const [first, ...rest] = user.name.trim().split(/\s+/);
            fn = first;
            ln = rest.join(' ');
        }

        // Meta hashes these automatically (SHA-256). Only include fields we actually have.
        const matching = {};
        if (user.email) matching.em = user.email;
        if (fn) matching.fn = fn;
        if (ln) matching.ln = ln;

        window.fbq('init', PIXEL_ID, matching);
    }, [isAuthenticated, user]);

    return null;
}
